import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { filter, map } from "rxjs/operators";
import { DataService } from "src/app/services/data.service";

// ESEMPIO DI CONFIGURAZIONE INPUT FIELD SOLA LETTURA
// {
//   "key": "titolo",
//   "type": "nginput",
//   "className": "col-12 h2",
//   "props": {
//       "label": "",
//       "labelClass":"", // la classe del label dell'input
//       "fieldClass": "h3", // la classe del valore dell'input
//       "readOnly": true
//   }
// }

@Component({
  selector: "formly-field-ng-input",
  template: `
    <!-- Template di un input field in sola lettura  -->
    <ng-container *ngIf="areReadOnly; else inputTemplate">
      <div *ngIf="props.label" [class]="props['labelClass']">
        <strong>{{ props.label }}</strong>
      </div>
      <div [class]="props['fieldClass']">
        <ng-container *ngIf="props['link']; else textValue">
          <a [href]="formControl.value" target="_blank" rel="noopener noreferrer">
            {{ formControl.value }}
          </a>
        </ng-container>
        <ng-template #textValue>
          {{ formControl.value }}
        </ng-template>
      </div>
    </ng-container>
    <!-- end -->

    <!-- Template di un input field  -->
    <ng-template #inputTemplate>
      <div class="mb-3">
        <label class="form-label" [for]="key" *ngIf="props.label">
          <strong>
            <span
              *ngIf="formControl.hasError('required')"
              [ngClass]="{ 'text-danger': formControl.touched || formControl.dirty }"
            >
              *
            </span>
          </strong>
        </label>
        <input
          class="form-control ng-valid"
          type="text"
          [formControl]="formControl"
          [formlyAttributes]="field"
          [id]="key.toString()"
          [required]="props.required ?? false"
        />
      </div>
      <div *ngIf="showError" class="col-3 invalid-feedback d-block">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>
    </ng-template>
    <!-- end -->
  `,
})
export class FormlyFieldNgInput extends FieldType<FieldTypeConfig> {
  areReadOnly: boolean = false;

  constructor(private dataService: DataService) {
    super();
  }

  ngOnInit() {
    this.areReadOnly = this.props["readOnly"];
    this.dataService.currentData$
      .pipe(
        filter((obj) => obj?.id && obj?.structureId === this.props["dependOn"]),
        map((obj) => obj[this.props["dependAttr"]])
      )
      .subscribe((value) => this.applyLogic(value));
  }

  applyLogic(value: string) {
    if (this.props["endpoint"] && value !== null) {
      this.dataService.getData(this.props["endpoint"] + "/" + value).subscribe((obj) => {
        this.formControl.setValue(obj.title);
      });
    } else {
      this.formControl.setValue(value);
    }
  }
}
